import classNames from 'classnames'
import SROnly from 'src/components/ui/SROnly'

export type ListingH1Props = {
  text: string
  variant: 'visible' | 'sr-only'
  className?: string
}

export function ListingH1({ text, variant, className }: ListingH1Props) {
  if (!text) {
    return null
  }

  if (variant === 'sr-only') {
    return <SROnly as="h1" text={text} />
  }

  return (
    <h1
      className={classNames(
        'font-inter text-heading-listing max-sm:text-heading-xs text-mainPrice mt-[29px] sm:mt-[59px] mb-[38px] restructure-small-desktop:mb-4 box-border w-full max-w-[1680px] mx-auto px-4 sm:px-8 md:px-0 intermediate:px-[42px]',
        className
      )}
    >
      {text}
    </h1>
  )
}

export default ListingH1
